import React, { useMemo } from "react";
import { Button, Modal } from "react-bootstrap";
import { ColumnSortingTable } from "./Table.js";
import {
  getImportValidationCategory,
  getImportValidationMessage,
  SelectColumnFilter,
} from "../assets/functions.js";

const formatValue = (value) => {
  if (value === null || value === undefined || value === "") return "—";
  if (Array.isArray(value)) return value.map((item) => String(item)).join(", ") || "—";
  if (typeof value === "object") {
    try {
      return JSON.stringify(value);
    } catch (_) {
      return String(value);
    }
  }
  return String(value);
};

export default function ImportValidationReportModal({ report, onClose }) {
  const errors = Array.isArray(report?.errors) ? report.errors : [];
  const tableData = useMemo(() => errors.map((error, index) => ({
    id: `${error.row ?? "file"}-${error.fieldId ?? error.fieldLabel ?? "general"}-${error.code ?? "error"}-${index}`,
    row: error.row ?? "Arquivo",
    email: error.email || "—",
    field: error.fieldLabel || "—",
    value: formatValue(error.value),
    category: getImportValidationCategory(error.code),
    code: error.code || "IMPORT_VALIDATION_FAILED",
    message: error.message || getImportValidationMessage(error),
  })), [errors]);

  const columns = useMemo(() => [
    {
      Header: "Linha",
      accessor: "row",
      Filter: SelectColumnFilter,
      filter: "equals",
      Cell: ({ value }) => (value === "Arquivo" ? value : `Linha ${value}`),
    },
    { Header: "E-mail", accessor: "email" },
    {
      Header: "Campo",
      accessor: "field",
      Filter: SelectColumnFilter,
      filter: "equals",
    },
    {
      Header: "Valor enviado",
      accessor: "value",
      Cell: ({ value }) => <span className="text-break">{value}</span>,
    },
    {
      Header: "Categoria",
      accessor: "category",
      Filter: SelectColumnFilter,
      filter: "equals",
      Cell: ({ value, row }) => (
        <>
          <div>{value}</div>
          <small className="text-muted">{row.original.code}</small>
        </>
      ),
    },
    {
      Header: "Como corrigir",
      accessor: "message",
      Filter: SelectColumnFilter,
      filter: "equals",
      disableSortBy: true,
      Cell: ({ value }) => <span className="text-break">{value}</span>,
    },
  ], []);

  return (
    <Modal show={Boolean(report?.open)} onHide={onClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Erros da importação</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ColumnSortingTable
          columns={columns}
          data={tableData}
          removeCard
          initialState={{ pageIndex: 0, pageSize: 20, sortBy: [{ id: "row", desc: false }] }}
          resetTrigger={report}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Fechar</Button>
      </Modal.Footer>
    </Modal>
  );
}
